import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';

interface Props {
  children: ReactNode;
  container?: Element;
}

/**
 * Mount it's children to the document body or the node passed as props.
 */
export const Portal: React.FunctionComponent<Props> = ({ children, container }) => {
  return ReactDOM.createPortal(children, container || document.body);
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/core/portal.component.tsx